import * as React from "react";
import { useNavigate } from "react-router-dom";
import Page from "app/components/Page";

import { useAppState } from "app/providers/AppStateProvider";
import SummaryView from "./components/SummaryView";
import VerifyOtp from "./components/VerifyOtp";
import Completed from "app/components/Payment/Completed";
import tw from "twin.macro";
import WaitingView from "./components/WaitingView";

type activeViewType = "confirm" | "verify" | "waiting" | "completed";

export default function BushaTransferConfirm() {
  const navigate = useNavigate();
  const { mode, merchant } = useAppState();
  const [activeView, setActiveView] = React.useState<activeViewType>("confirm");

  const isLive = mode === "live";

  const canGoBack = ["confirm", "verify"].includes(activeView)

  return (
    <Page
      onBack={!canGoBack ? undefined : activeView !== "confirm" ? () => setActiveView("confirm") : () => navigate(-1)}
    >
      <div tw="flex flex-col h-full">
        {canGoBack &&
          (<div tw="flex items-center gap-[10px] mb-[24px]">
            <div tw="grow">
              <h4 css={tw`headline-medium`}>Confirm payment</h4>
            {/* <p css={tw`body-large text-text-mid`}>
              To <span tw="font-semibold">{merchant.business_name}</span>
            </p> */}
          </div>

          {/* <h3 tw="title-medium h-[56px] w-[56px] flex items-center justify-center rounded-full bg-containment-tertiary">
            {merchant.business_name ? merchant.business_name[0] : ""}
          </h3> */}
          </div>
          )}
        {isLive && (
          <>
            {activeView === "confirm" && (
              <SummaryView onDone={(options) => setActiveView(options?.skipVerify ? "waiting" : "verify")} />
            )}

            {activeView === "verify" && (
              <VerifyOtp onDone={() => setActiveView("waiting")} />
            )}

            {activeView === "waiting" && <WaitingView onDone={() => setActiveView("completed")} />}

            {activeView === "completed" && <Completed />}
          </>
        )}
      </div>
    </Page>
  );
}
